<div
  class="contentblock"
  [class.mobil]="zustand != 'web'"
  [class.web]="zustand == 'web'"
  [innerHTML]="zwischenseiteContent | img | async"
></div>
